class pluginController {
    constructor($scope, AppConfig, PluginVersionAPI, dateFilter) {
        "ngInject";
        this.version='-'
        this.download_url='-';
        this.latest_version='';
        PluginVersionAPI.one().get({
            plugin_id: AppConfig.plugin_id
        })
          .then(res => {
              console.log(res)
              this.latest_version = res.data.latest_version;
              this.version = `V${res.data.latest_version} - ${dateFilter(res.data.updated_at * 1000, 'yyyy.MM.dd')}`
              this.browserType='chrome';
          })
      
      $scope.$watch('$ctrl.browserType', (newV, oldV) => {
        if (newV === 'chrome') {
          this.download_url = `https://yb-public.oss-cn-shanghai.aliyuncs.com/yuanben-${this.latest_version}_0.crx`
        } else {
          this.download_url = `https://yb-public.oss-cn-shanghai.aliyuncs.com/yuanben-${this.latest_version}.crx`
        }
      })
    }
    // download_ext(){
    //     $('#install-panel').addClass('active');
    //     window.location.href=this.download_url
    // }
}

export default pluginController;



// WEBPACK FOOTER //
// ./src/app/components/face/plugin/plugin.controller.js